export default __webpack_public_path__ + "static/media/sm-bullet.513b0d51.svg";